// src/components/WithRoleGuard.jsx
import React from "react";
import { Navigate } from "react-router-dom";

/**
 * 권한 기반 라우팅 가드 컴포넌트
 * @param {React.ComponentType} component - 보호할 컴포넌트
 * @param {string[]} allowedRoles - 허용할 역할 (기본: ROLE_USER 제외)
 */
const WithRoleGuard = ({ component: Component, allowedRoles }) => {
  const role = localStorage.getItem("role");

  // 기본값: ROLE_USER 제외하고 관리자 권한만 허용
  const effectiveRoles = allowedRoles ?? ["ROLE_ADMIN", "ROLE_SUPERVISOR", "ROLE_MASTER"];

  if (!role || !effectiveRoles.includes(role)) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return <Component />;
};

export default WithRoleGuard;